import http from "../HttpService";

const controller = "/menu/fe/";

function getUrlItem(sectionCode) {
  return `${controller}section/${http.GUID}/${sectionCode}`;
}

function getUrlItemMenu() {
  return `${controller}${http.GUID}`;
}

export function getItem(sectionCode) {
  return http.get(getUrlItem(sectionCode));
}

export function getMenu() {
  return http.get(getUrlItemMenu());
}
